import React, { Component } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import Message from 'jl-design-system/components/message/Message';
import Link from 'jl-design-system/elements/link/Link';
import getRegisteredFieldValues from 'jl-design-system/form/helpers/getRegisteredFieldValues';
// redux
import { connect } from 'react-redux';
import { submitAndHandleLogin } from '../../redux/actions/login/loginActions';
import { isPactApp } from '../../redux/reducers/app/appReducer';
import urlConstants from '../../constants/urlConstants';
// components
import LoginChoice from '../../components/login-choice/LoginChoice';
// utils
import setPageTitle from '../../utils/helpers/pageTitle';
// styles
import styles from './login.scss';


export class Login extends Component {
  static propTypes = {
    auth0Failure: PropTypes.bool,
    isPactApp: PropTypes.bool,
    loginApiCallActive: PropTypes.bool,
    loginForm: PropTypes.shape({
      registeredFields: PropTypes.shape({}),
    }),
    showEmailValidationError: PropTypes.bool,
    submitAndHandleLogin: PropTypes.func,
    userEmail: PropTypes.string,
  };

  static defaultProps = {
    auth0Failure: false,
    isPactApp: false,
    loginApiCallActive: false,
    loginForm: undefined,
    showEmailValidationError: false,
    submitAndHandleLogin: window.defaultFunc,
    userEmail: '',
  };

  componentDidMount() {
    setPageTitle('Sign in');
  }

  onFormSubmit = (data = {}) => {
    const { submitAndHandleLogin, loginForm } = this.props;
    // ensure only registered fields are submitted in form
    const body = { ...getRegisteredFieldValues(data, loginForm.registeredFields) };
    return submitAndHandleLogin(body);
  };

  render() {
    const {
      loginApiCallActive,
      isPactApp,
      userEmail,
      auth0Failure,
      showEmailValidationError,
    } = this.props;

    return (
      <div className={styles.container} data-test="login-container">

        <h1 className={styles.title} data-test="login-title">Welcome to secure checkout</h1>

        {
          auth0Failure &&
          <Message
            animation="shake"
            body={<>You can <Link data-action="handback" to={urlConstants.BASKET_PAGE_URL}>return to your basket</Link>  and try to sign in again, or you can check out as a guest.</>}
            data-test="fallback-error-message"
            title="Sorry, we can’t sign you in at the moment"
            type="error"
          />
        }

        <LoginChoice
          auth0Failure={auth0Failure}
          loginApiCallActive={loginApiCallActive}
          onFormSubmit={this.onFormSubmit}
          showEmailValidationError={showEmailValidationError}
          showPartnerAppText={isPactApp}
          userEmail={userEmail}
        />

      </div>
    );
  }
}

export default connect(state => ({
  loginApiCallActive: state.login.apiCallActive,
  loginForm: state.form.guestForm,
  isPactApp: isPactApp(state),
  userEmail: state.user.email,
  auth0Failure: !!state.auth0Callback.callbackError,
  showEmailValidationError: state.login.showEmailValidationError,
}), {
  submitAndHandleLogin,
})(Login);
